module.exports = __webpack_public_path__ + "img/6.70f88895.png";